import { combineReducers } from '@reduxjs/toolkit'
import common from './commonSlice'
import daExtension from './daExtensionSlice'

const reducer = combineReducers({
    common,
    daExtension,
})

export default reducer
